import { useContext } from 'react';
import { Card, CardContent, CardActions, CircularProgress, Button, Grid, Link } from '@material-ui/core';
import { Page, PageHeader, CircleLoader } from 'components';
import { excelImportContext } from './ExcelImportContext';
import { Content } from './components';
import { Alert } from '@material-ui/lab';


let ImportExcelFiles = () => {

    let service = useContext(excelImportContext);


    return (
        <>
            {service.isLoading === true && <CircleLoader />}
            {service.isLoading === false &&
                <Page >
                    <PageHeader pageTitle="Import Excel Status" />
                    <Card>
                        <CardContent>
                            <Content />
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    {service.isImporting &&
                                        <Alert severity="info">
                                            The Excel Import operation is currently in progress, you can close this page and check the upload status
                                            <Link variant="body1" href={'/importrequests'}>&nbsp;here</Link>
                                        </Alert>
                                    }
                                    {service.isImported &&
                                        <Alert severity="success">The Excel Import operation it was completed successfully, all data is updated</Alert>
                                    }
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions>
                            <Grid container>
                                <Grid item xs />
                                <Grid item>
                                    {service.isImported === false &&
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={
                                                service.isImporting ||
                                                service.excelImport.status.isFileValid === false
                                            }
                                            onClick={() => service.doImport()}
                                        >
                                            {service.isImporting && <CircularProgress size={20} />}&nbsp;Import file
                                        </Button>
                                    }
                                </Grid>
                            </Grid>
                        </CardActions>
                    </Card>
                </Page>
            }
        </>
    )
}

export default ImportExcelFiles;